import { Dropdown } from "primereact/dropdown";
import styled from "styled-components";

export const CheckAllProductTemplateStyled = styled.div`
    .p-inputgroup-addon{
        background: none;
        border: none;
        min-width: 2rem;
        padding: 0px 2px 0px 12px;
    }
`

export const DropdownCheckTemplate = styled(Dropdown)`
    border: none;

    &:not(.p-disable).p-focus{
        box-shadow: none;
    }

    .p-dropdown-label-empty{
        visibility: unset;
        background: none;
    }

    .p-dropdown-label{
        display: none;
    }

    .p-dropdown-trigger{
        width: 20px;
    }
`